
import BootstrapTable from "react-bootstrap-table-next";
import {
    Card,
    CardBody,
    CardHeader,
    Input,
    Label,
    Modal,
} from "reactstrap";
import React, { useEffect, useMemo, useState } from "react";
import { getChangedParties } from "./PartyItems";

const ChannelViewDetails = ({ ModalOpen, setShowModal, OriginalData, RowId, ItemName }) => {

    const [modal_view, setModal_view] = useState(ModalOpen);
    const [tableData, setTableData] = useState([]);
    const [searchText, setSearchText] = useState(""); // ✅ search

    // ✅ Initialize table data
    useEffect(() => {
        const currentItem = OriginalData.find(item => item.Item === RowId);

        if (currentItem) {
            setTableData(structuredClone(currentItem.MutablePartyData));
        }
    }, [OriginalData, RowId]);

    // ✅ Updated data (for parent)
    const updatedData = useMemo(() => {
        return OriginalData.map(item => {
            if (item.Item === RowId) {
                return {
                    ...item,
                    MutablePartyData: structuredClone(tableData)
                };
            }
            return item;
        });
    }, [OriginalData, RowId, tableData]);

    // ✅ Modal close
    function modalToggleFunc() {
        setModal_view(false);

        setShowModal(prev => ({
            ...prev,
            InitialData: updatedData,
            RowId: null,
            ModalOpen: false
        }));
    }



    // ✅ Filtered data (SEARCH)
    const filteredData = useMemo(() => {
        if (!searchText) return tableData;

        return tableData.filter(item =>
            item.Name?.toLowerCase().includes(searchText.toLowerCase())
        );
    }, [tableData, searchText]);

    // ✅ Counts
    const selectedCount = tableData?.filter(p => p.selectCheck).length;

    // ✅ Columns
    const pagesListColumns = [
        {
            text: "Party Name",
            dataField: "Name",
        },
        {
            text: "Status",
            dataField: "Name",
            headerStyle: { width: "180px" },
            style: { width: "180px" },
            formatter: (cell, row) => (
                <div className="d-flex flex-wrap gap-1 mt-1">

                    {row?.InStock ? (
                        <span className="party-status-instock">In Stock</span>
                    ) : (
                        <span className="party-status-unassign">Out of Stock</span>
                    )}

                    {row?.IsBOMItem && (
                        <span className="party-status-bom">BOM Item</span>
                    )}

                    {(row.UploadSalesDatafromExcelParty && row.MapItem) && (
                        <span className="party-status-bom">Item Not Map</span>
                    )}
                </div>
            )
        }
    ];

    // ✅ Non selectable rows
    const nonSelectedRow = (tableArray) => {
        return tableArray?.filter(row =>
                row.InStock === true ||
                row.IsBOMItem ||
                (row.UploadSalesDatafromExcelParty && row.MapItem)
            )
            .map(row => row.id);
    };

    // ✅ Selected rows
    const rowSelected = (tableArray) => {
        return tableArray?.filter(row => row.selectCheck)
            .map(row => row.id);
    };

    // ✅ Select config
    const tableSelectCheckConfig = ({
        rowSelected = [],
        nonSelectable = [],
        keyField,
        tableData = []
    }) => ({

        mode: "checkbox",

        onSelectAll: (isSelect) => {
            setTableData(prev =>
                prev.map(item =>
                    nonSelectable.includes(item[keyField])
                        ? item
                        : { ...item, selectCheck: isSelect }
                )
            );
        },

        onSelect: (row, isSelect) => {
            setTableData(prev =>
                prev.map(item =>
                    item.id === row.id
                        ? { ...item, selectCheck: isSelect }
                        : item
                )
            );
        },

        selected: rowSelected,
        selectColumnPosition: "right",

        attrs: () => ({ 'data-label': "Select" }),

        selectionHeaderRenderer: () => {
            const selectableRows = tableData.filter(
                r => !nonSelectable.includes(r[keyField]) && !r.IsBOMItem
            );

            const allSelected =
                selectableRows.length > 0 &&
                selectableRows.every(r => r.selectCheck);

            return (
                <div>
                    <Input type="checkbox" checked={allSelected} readOnly />
                    <label style={{ paddingLeft: "7px" }}>Select All</label>
                </div>
            );
        },

        selectionRenderer: ({ checked, rowKey, ...rest }) => {

            const changed = getChangedParties(RowId, updatedData);

            const matched = changed?.find(p => p.id === rowKey);
            const isNonSelectable = nonSelectable.includes(rowKey);

            if (isNonSelectable) {
                return (
                    <Input type="checkbox" checked={checked} disabled />
                );
            }

            return (
                <div className="d-flex gap-2">
                    <Input type="checkbox" {...rest} checked={checked} />

                    {matched && (
                        <span
                            className={
                                matched.selectCheck
                                    ? "party-status-assign"
                                    : "party-status-unassign"
                            }
                        >
                            {matched.selectCheck ? "Assigned" : "Unassigned"}
                        </span>
                    )}
                </div>
            );
        }
    });

    // ✅ Open modal
    useEffect(() => {
        setModal_view(true);
    }, [ModalOpen]);

    return (
        <Modal
            isOpen={modal_view}
            toggle={modalToggleFunc}
            centered
            size="xl"
        >
            <Card>
                <CardHeader className="text-center">
                    <div style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: "8px" }}>

                        {/* Item Name */}
                        <span style={{ fontSize: "20px", fontWeight: "600" }}>
                            {ItemName}
                        </span>

                        {/* Separator */}
                        <span style={{ color: "#999" }}>|</span>

                        {/* Label */}
                        <span style={{ fontSize: "16px", color: "#555" }}>
                            Parties Assign
                        </span>

                    </div>
                </CardHeader>

                <CardBody className="c_card_body">

                    {/* 🔍 SEARCH + COUNT */}
                    <div className="d-flex justify-content-between align-items-center mb-2">

                        <Input
                            type="text"
                            placeholder="Search Party..."
                            value={searchText}
                            onChange={(e) => setSearchText(e.target.value)}
                            style={{ maxWidth: "250px" }}
                        />

                        <div className="fw-bold">
                            Total: {filteredData?.length} / {tableData?.length} | Selected: {selectedCount}
                        </div>

                    </div>

                    <div className="table-responsive">
                        <BootstrapTable
                            keyField="id"
                            data={filteredData}   // ✅ filtered
                            columns={pagesListColumns}
                            bordered
                            selectRow={tableSelectCheckConfig({
                                nonSelectable: nonSelectedRow(tableData),
                                rowSelected: rowSelected(tableData),
                                keyField: "id",
                                tableData: tableData
                            })}
                            striped={false}
                            noDataIndication={
                                <div className="text-danger text-center">
                                    Record Not Available
                                </div>
                            }
                            headerWrapperClasses="thead-light"
                        />
                    </div>
                </CardBody>
            </Card>
        </Modal>
    );
};

export default ChannelViewDetails;